import React from "react";
import { makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import { useParams } from "react-router-dom";
import AssistanceContainer from "../containers/mobile-frame/AssistanceContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
    },
  },
}));

const AssistancePage = () => {
  const classes = useStyles();
  let { eklok } = useParams();

  return (
    <Page className={classes.root} title="Assistance">
      <AssistanceContainer eklok={eklok} />
    </Page>
  );
};

export default AssistancePage;
